import { render, staticRenderFns } from "./MaiLive.vue?vue&type=template&id=6aab80b7&scoped=true&"
import script from "./MaiLive.vue?vue&type=script&lang=js&"
export * from "./MaiLive.vue?vue&type=script&lang=js&"
import style0 from "./MaiLive.vue?vue&type=style&index=0&id=6aab80b7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aab80b7",
  null
  
)

export default component.exports